export interface Affise {
  clickId?: string;
  utmCampaign?: string;
}
